import toast from 'react-hot-toast';
import { Trans } from 'react-i18next';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { NOTIFICATION_STATUS, NOTIFICATION_TYPE } from '@hero/constants';

const initialState = {
  type: NOTIFICATION_TYPE.modal,
  notificationStatus: NOTIFICATION_STATUS.initial,
  notificationImage: '',
  notificationIcon: '',
  isOpen: false,
  customContent: () => {},
  header: '',
  title: '',
  message: '',
  popupStyle: {},
  primaryButtonProps: {
    color: 'primary'
  },
  onSubmit: () => {},
  secondaryButtonProps: {
    color: 'secondary'
  },
  isPrimaryButtonDisabled: false,
  onClose: () => {},
  headerStyle: {},
  messageStyle: {},
  titleStyle: {},
  formStyle: {},
  formValidationSchema: null,
  formData: null,
  formSettings: {},
  notification: null,
  size: 'sm',
  onBack: null
};

const TOAST_STATUS = {
  initial: 'initial',
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info'
};

const TOAST_CLASSNAME = {
  initial: 'toast-wrapper default',
  success: 'toast-wrapper success',
  warning: 'toast-wrapper warning',
  error: 'toast-wrapper error',
  info: 'toast-wrapper info'
};

function showToast(payload, status) {
  toast(
    {
      title: payload.title,
      message: payload.message,
      icon: payload.icon,
      status
    },
    {
      ...payload.toastOptions,
      className: TOAST_CLASSNAME[status]
    }
  );
}

let store = (set, _get) => ({
  ...initialState,
  showNotification: payload => {
    if (payload.type === NOTIFICATION_TYPE.toast) {
      showToast(payload, TOAST_STATUS.success);
      return;
    }
    set({
      primaryButtonProps: {
        children: <Trans i18nKey="okay" />
      },
      ...payload,
      isOpen: true
    });
  },
  showSuccess: payload => {
    if (payload.type === NOTIFICATION_TYPE.toast) {
      showToast(payload, TOAST_STATUS.success);
      return;
    }
    set({
      ...payload,
      notificationStatus: NOTIFICATION_STATUS.success,
      isOpen: true
    });
  },
  showWarning: payload => {
    if (payload.type === NOTIFICATION_TYPE.toast) {
      showToast(payload, TOAST_STATUS.warning);
      return;
    }
    set({
      ...payload,
      notificationStatus: NOTIFICATION_STATUS.warning,
      isOpen: true
    });
  },
  showError: payload => {
    if (payload.type === NOTIFICATION_TYPE.toast) {
      showToast(payload, TOAST_STATUS.error);
      return;
    }
    set({
      ...payload,
      primaryButtonProps: {
        center: true,
        color: 'error',
        children: <Trans i18nKey="okay" />
      },
      notificationStatus: NOTIFICATION_STATUS.error,
      isOpen: true
    });
  },
  showInfo: payload => {
    if (payload.type === NOTIFICATION_TYPE.toast) {
      showToast(payload, TOAST_STATUS.info);
      return;
    }
    set({
      ...payload,
      notificationStatus: NOTIFICATION_STATUS.info,
      isOpen: true
    });
  },
  close: () => set({ isOpen: false }),
  reset: () => set(initialState)
});

export const useNotification = create(devtools(store));
